import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll } from "./rdetailAPI";

const initialState = {
  value: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
};

export const fetchAll = createAsyncThunk("rdetail/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const rdetailSlice = createSlice({
  name: "rdetail",
  initialState,
  reducers: { resetData: (state) => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      });
  },
});

export const { resetData } = rdetailSlice.actions;

export const selectData = (state) => state.rdetail.value;
export const selectLoading = (state) => state.rdetail.loading;
export const selectError = (state) => state.rdetail.error;
export const selectPageNo = (state) => state.rdetail.pageNo;
export const selectPageSize = (state) => state.rdetail.pageSize;
export const selectTotalRecord = (state) => state.rdetail.totalRecord;

export default rdetailSlice.reducer;
